import { z } from "zod";

export const giftHistorySchema = z.object({
  gifts: z.array(
    z.object({
      purchase_date: z.iso.datetime(),
      promo_code: z.string(),
      redemption: z
        .object({
          date: z.iso.datetime(),
        })
        .nullable(),
    }),
  ),
});

export type GiftHistory = z.infer<typeof giftHistorySchema>;
